import React from 'react';
import classNames from 'classnames';

import Image from 'components/Common/Medias/Image';
import { ENV_TWICPICS_URL_MEDIA } from 'settings/env';

import styles from './CartProductWrapper.module.scss';

export default function CartProductWrapper({
  children,
  classes,
  image,
  title,
  LinkComponent = React.Fragment,
}: CartProductWrapperType): JSX.Element {
  return (
    <div className={classNames(styles.container, classes?.container)}>
      <div className={classNames(styles.title, classes?.title)}>
        <LinkComponent>{title}</LinkComponent>
      </div>
      <div className={classNames(styles.content, classes?.content)}>
        <LinkComponent>
          <Image
            className={classNames(styles.image, classes?.image)}
            src={ENV_TWICPICS_URL_MEDIA + image}
          />
        </LinkComponent>
        <div className={classNames(styles.details, classes?.details)}>
          {children}
        </div>
      </div>
    </div>
  );
}

type CartProductWrapperType = React.PropsWithChildren<{
  classes?: CartProductWrapperClassesType;
  image: string;
  title: string;
  LinkComponent?: React.FC<{ children: React.ReactNode }>;
}>;

type CartProductWrapperClassesType = {
  container?: string;
  content?: string;
  details?: string;
  image?: string;
  title?: string;
};
